"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EntityType;
(function (EntityType) {
    EntityType["Relation"] = "relation";
    EntityType["Project"] = "project";
    EntityType["Task"] = "task";
    EntityType["Order"] = "order";
    EntityType["Article"] = "article";
})(EntityType = exports.EntityType || (exports.EntityType = {}));
var Errors;
(function (Errors) {
    Errors[Errors["EntityNotFound"] = 0] = "EntityNotFound";
    Errors[Errors["CompendaNotResponding"] = 1] = "CompendaNotResponding";
})(Errors = exports.Errors || (exports.Errors = {}));
var CompendaStatus;
(function (CompendaStatus) {
    CompendaStatus["Opened"] = "opened";
    CompendaStatus["Closed"] = "closed";
    CompendaStatus["NotFound"] = "not found";
})(CompendaStatus = exports.CompendaStatus || (exports.CompendaStatus = {}));
